export const IS_NEXT_PAGE = "is-next-page";
